<script>
import ListView from '@/arch/components/data-table/ListView.vue'
import { mapActions, mapGetters } from 'vuex'
import DataTableLinkText from '@/arch/components/data-table/columns/DataTableLinkText'
import DataTableChipStatus from '../orders-details/components/DataTableChipStatus.vue'
import { VUE_APP_DECIMALS, VUE_APP_COUNTRY, VUE_APP_API_URL } from '@/config'
import utils from '@/utils';
import axios from 'axios';

export default {
  extends: ListView,
  name: 'ViewListOrders',
  data() {
    return {
      namePage: this.$i18n.t('orders'),
      path: 'orders',
      filterContent: () => import('./components/OrdersFiltersComponent.vue'),
      headerContent: () => import('./components/OrdersHeaderComponent.vue'),
      hideDefaultActions: true,
      addNew: false,
      dataProperties: { path: 'orders', namePage: this.$i18n.t('orders') },
      headers: [
        {
          text: this.$i18n.t('orderNumber'),
          align: 'start',
          sortable: true,
          value: 'SALES_ORDER',  
          component: DataTableLinkText,
          options: { to: { name: 'OrderDetails' }, field: 'SALES_ORDER', transform: (value) => value }      
        },
        {
          text: this.$i18n.t('purchaseOrder'),
          align: 'start',
          sortable: true,
          value: 'CUSTOMER_PO',
        },
        {
          text: this.$i18n.t('createdDate'),
          align: 'start',
          sortable: true,
          value: 'CREATION_DATE',
        },
        this.validateCountryColumn(),
        {
          text: this.$i18n.t('totalValue'),
          align: 'start',
          sortable: true,
          value: 'TOTAL',
          component: 'DataTableCurrencyColumn',
          options: {
            prefix: '$',
            dynamicPrefix: 'CURRENCY',
            decimals: VUE_APP_DECIMALS
          }
        },
        {
          text: this.$i18n.t('status'),
          align: 'start',
          sortable: true,
          value: 'STATUS_HEADER',
          component: DataTableChipStatus
        },
      ],
      thisPage: 'pedido'
    }
  },
  computed: {
    ...mapGetters('ordersStore', {
      getGoodList: 'getList',
    }),
  },
  created(){
    this.saveAccessPage();
  },
  methods: {
    ...mapActions('ordersStore', ['setDefaultPath']),
    ...mapActions({
      setDataToList(dispatch, payload) {
        return dispatch(this.getPathStore + '/setDataToList', {
          ...payload,
          type: 'sales'
        })
      }
    }),
    validateCountryColumn(){

      if(VUE_APP_COUNTRY == 'EC'){
        return {
          text: this.$i18n.t('shippingLocation'),
          align: 'start',
          sortable: false,
          value: 'SHIPPING_INSTRUCTIONS',
        }
      }
      return {
        text: this.$i18n.t('shippingLocation'),
        align: 'start',
        sortable: false,
        value: 'SHIP_TO',
      }
    },
    async saveAccessPage(){
      let country = utils.loadCountry();
      let userid = utils.loadUserId();

      axios.post(`${VUE_APP_API_URL}venusa/saveAccessPage`, { UNIDADE_PAIS: country, USERID: userid, THISPAGE: this.thisPage, TOKEN: utils.loadToken() });
    }
  },
}
</script>